import { canPaginate } from '../../mixins/can_paginate';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/tickets', {
        template: require('./tickets.html'),
        controller: 'TicketsController'
    });
})
.controller('TicketsController', function($scope, $location, $modal, Ticket, Config, Channel) {
    $scope.config = Config;
    $scope.loading = true;

    canPaginate($scope, $location);
    $scope.s || ($scope.s = '-created_at');
    $scope.type = $location.search().type || 'broadcast';

    $scope.tickets = Ticket.queryGlobal(_.pick($scope, 'q', 's', 'p', 'type'), function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });

    $scope.setType = t => $location.search('type', t);

    $scope.show = ($event, t) => {
      if (t.broadcast_id) {
        $scope.openURL(`/broadcasts/${t.broadcast_id}/tickets/${t.id}`, $event);
      } else {
        Channel.get(
          {id: t.channel_id, include_archived: true},
          channel => {
            if (channel.account_id) {
              $scope.openURL(`/accounts/${channel.account_id}/channels/${channel.id}/tickets/${t.id}`, $event);
            } else {
              alert("This channel is a multi-account channel; unable to redirect to ticket purchase.");
            }
          }, e => {
            console.error(e);
            alert("Unable to look up channel");
          }
        );
      }
    }
});


// WEBPACK FOOTER //
// ./views/tickets/tickets_controller.js